var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-duration-5728341 1",
    clipPath: "url(#clip0_641_132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.13994 3.36393C4.87175 3.09574 4.89834 2.65166 5.21428 2.44181C6.69837 1.4561 8.47937 0.881836 10.3945 0.881836C15.5722 0.881836 19.7695 5.07918 19.7695 10.2568C19.7695 15.4345 15.5722 19.6318 10.3945 19.6318C5.21688 19.6318 1.01953 15.4345 1.01953 10.2568C1.01953 8.16962 1.70161 6.24171 2.85504 4.68387C3.07285 4.38968 3.4989 4.37452 3.75772 4.63337C3.98816 4.86377 4.00206 5.23059 3.81084 5.49446C2.8412 6.83259 2.26953 8.47796 2.26953 10.2568C2.26953 14.7441 5.90722 18.3818 10.3945 18.3818C14.8818 18.3818 18.5195 14.7441 18.5195 10.2568C18.5195 5.76952 14.8818 2.13184 10.3945 2.13184C8.76487 2.13184 7.24728 2.61162 5.97528 3.43765C5.71197 3.60862 5.36194 3.58593 5.13994 3.36393Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3945 5.10059C10.7397 5.10059 11.0195 5.3804 11.0195 5.72559V9.99796L13.649 12.6274C13.8931 12.8715 13.8931 13.2672 13.649 13.5113C13.4049 13.7554 13.0092 13.7554 12.7651 13.5113L9.95259 10.6988C9.83538 10.5816 9.76953 10.4226 9.76953 10.2568V5.72559C9.76953 5.3804 10.0493 5.10059 10.3945 5.10059Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.314453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.3d6e4168674366c978f32661e6d46eb7.svg";
export { ForwardRef as ReactComponent };